import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'tr-notfound',
  imports: [CommonModule, ButtonModule, RouterModule],
  templateUrl: './NotFound.component.html',
  styleUrl: './NotFound.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent implements OnInit {
  ngOnInit(): void {}
}
